<template>
  <div class="frame">
    <button class="actionButton" @click.self="commonOpen">
      {{ openBtnText }}
    </button>
    <div id="weixinLayout" v-show="weixinShow" class="weixinDiv">
      <wx-open-launch-app
        ref="wxOpen"
        v-html="buttonHtml"
        appid="wx3ebc9e606b4f9242"
        :extinfo="weixinExtraData"
        @ready="onReady"
        @launch="onLaunch"
        @error="onError"
      >
      </wx-open-launch-app>
    </div>
  </div>
</template>

<script lang="ts" setup>
import {
  onMounted,
  ref,
  defineEmits,
  defineProps,
  // type CSSProperties,
  // computed,
  withDefaults,
} from 'vue';
import Vrouter from '@/router';
import OpenWpsBridge from '../bridge/OpenWpsBridge';
import DeviceEnvUtil from '../../utils/DeviceEnvUtil';
import WxService from '../service/WxService';
import KLog from '../../utils/KLog';
import AbilityParamsUtil from '../bridge/AbilityParamsUtil';
import { ShareContent } from '../bridge/ShareObject';
import i18n from '@/i18n';
import { openStoreByPlatform } from '../../utils/StoreConfig';
import { getAppIcon } from '../../utils/RegionAssets';

export interface OpenButtonStyle {
  position?: string;
  left?: string;
  background: string;
  'border-radius': string;
  'border-width': string;
  width: string;
  height: string;
  'font-size': string;
  color: string;
  'text-decoration-line': string;
  'text-align'?: string;
}

export interface RealButtonStyle {
  'font-size': string;
  color: string;
  'text-decoration-line': string;
}

interface OpenButtonProps {
  openBtnStyleObj: OpenButtonStyle;
  openBtnText: string;
}

const emit = defineEmits(['commonOpen', 'onWeixinLaunch', 'onWeixinLaunchFail']);

const props = withDefaults(defineProps<OpenButtonProps>(), {
  openBtnStyleObj: () => ({
    background: '#00FF00',
    'border-radius': '18px',
    'border-width': '0px',
    width: '300px',
    height: '54px',
    'font-size': '18px',
    color: '#fff',
    'text-decoration-line': 'none',
  }),
  openBtnText: i18n.global.t('common.openWpsExperience'),
});

// const openButtonStyle = computed(() => {
//   return {
//     ...props.openBtnStyleObj,
//   } as CSSProperties;
// });

const weixinShow = ref(false);
const weixinExtraData = ref('');

const buttonHtml = ref();

// const buttonRef = ref();

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function onReady(e: any) {
  KLog.log('onReady', e);
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
// function proxyOpen(event: any) {
//   event.stopPropagation();
//   if (weixinShow.value) {
//     buttonRef.value.$.vnode.el?.click();
//   } else {
//     openAction();
//   }
// }

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function commonOpen() {
  // event.stopPropagation();
  openAction();
}

function openAction() {
  emit('commonOpen');
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unused-vars
function onLaunch(e: any) {
  autoJumpDownload();
  emit('onWeixinLaunch');
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unused-vars
function onError(e: any) {
  if (e.detail.errMsg === 'launch:fail') {
    openStoreByPlatform(AbilityParamsUtil.getDownloadUrl());
  }
  emit('onWeixinLaunchFail');
}

function autoJumpDownload() {
  setTimeout(() => {
    Vrouter.push({
      path: '/mobile_avocado_ck/download',
      query: {
        chan: AbilityParamsUtil.getDownloadChan(),
        autoJump: AbilityParamsUtil.isAutoJumpDownload() ? '1' : '0',
        ability: AbilityParamsUtil.getAbilityName(),
        _business_id: AbilityParamsUtil.getAbilityBusinessId(),
      },
    });
  }, 1000);
}

function initButtonStyle() {
  let width = props.openBtnStyleObj.width;
  let height = props.openBtnStyleObj.height;
  if (width.indexOf('%') > -1) {
    width = '300px';
  }
  if (height.indexOf('%') > -1) {
    height = '54px';
  }
  let html = [
    ' <script type="text/wxtag-template">',
    '   <style>.weixinLayout {',
    '     opacity: 0;',
    '     width: ',
    width,
    ';',
    '     height: ',
    height,
    ';',
    '     }',
    '   </style>',
    '   <div class="weixinLayout"></div>',
    '</scrip' + 't>',
  ].join('');
  buttonHtml.value = html;
}

function showWeixinOpen() {
  weixinShow.value = true;
}

function showCommonOpen() {
  weixinShow.value = false;
}

function initOpenButton() {
  initButtonStyle();
  let shareContent: ShareContent = AbilityParamsUtil.getShareObj().share_content;
  if (shareContent.title === undefined || shareContent.title === '') {
    shareContent.title = i18n.global.t('common.wpsOffice');
  }
  if (shareContent.desc === undefined || shareContent.desc === '') {
    shareContent.desc = i18n.global.t('template.desc');
  }
  if (shareContent.icon === undefined || shareContent.icon === '') {
    shareContent.icon = getAppIcon();
  }
  if (DeviceEnvUtil.isWeixin()) {
    if (AbilityParamsUtil.isUseWxOpenTag()) {
      let currentUrl = window.location.href;
      weixinExtraData.value = OpenWpsBridge.translateNewDeeplink();
      WxService.loadWxSDK()
        .then(() => {
          WxService.requestSign(currentUrl)
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            .then((res: any) => {
              WxService.initConfig(
                shareContent,
                {
                  ...res.data,
                },
                () => {
                  KLog.log('initConfig success');
                  showWeixinOpen();
                },
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                (error: any) => {
                  KLog.log('initConfig fail: ', error);
                  showCommonOpen();
                },
              );
            })
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            .catch((error: any) => {
              KLog.log('requestSign error: ', error);
              showCommonOpen();
            });
        })
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        .catch((error: any) => {
          KLog.log('loadWxSDK error: ', error);
          showCommonOpen();
        });
    } else {
      KLog.log('Anthorization fail: ');
      showCommonOpen();
    }
  } else {
    showCommonOpen();
  }
}

onMounted(() => {
  initOpenButton();
});
</script>

<style scoped>
.frame {
  position: relative;
  align-items: center;
  margin: auto;
  width: 280px;
  height: 48px;
  border-radius: 18px;
  /* stylelint-disable-next-line order/properties-order */
  font-size: 16px;
  color: #ffffff;
  background: #3b64fc;
}

.actionButton {
  position: absolute;
  left: 0;
  width: 100%;
  height: 100%;
  border-width: 0;
  background-color: transparent;
  /* stylelint-disable-next-line order/properties-order */
  font-size: 16px;
  color: #ffffff;
  text-decoration-line: none;
}

.weixinDiv {
  position: absolute;
  left: 0;
  width: 100%;
  height: 100%;
}
</style>
